/**
 * Instructor feature flags are strict, build-time opt-ins.
 *
 * Keep this aligned with the learner app: an unset, empty, or differently
 * cased value is disabled so the UI cannot expose a workflow before its
 * backend and database rollout are ready.
 */
export function isHitlFeatureEnabled(
  value: string | undefined = process.env.REACT_APP_HITL_ENABLED,
): boolean {
  return value === 'true';
}

export const HITL_ENABLED = isHitlFeatureEnabled();
